(() => {
  const drawer = document.getElementById('search-drawer');
  if (!drawer || drawer.dataset.gcSearchBound) return;
  const input = drawer.querySelector('#search-drawer-input');
  const form = drawer.querySelector('#predictive-search-form');
  const results = drawer.querySelector('predictive-search [slot="results"]');
  const status = drawer.querySelector('#gc-search-status');
  const footer = drawer.querySelector('.gc-search-footer');
  if (!input || !form || !results || !status || !footer) return;
  drawer.dataset.gcSearchBound = 'true';
  function syncQuery() {
    const hasQuery = input.value.trim().length > 0;
    footer.hidden = !hasQuery;
    if (!hasQuery) {
      status.textContent = '';
      results.removeAttribute('aria-busy');
    } else {
      results.setAttribute('aria-busy', 'true');
    }
  }
  input.addEventListener('input', syncQuery);
  form.addEventListener('reset', () => setTimeout(syncQuery, 0));
  new MutationObserver(() => {
    results.removeAttribute('aria-busy');
    if (!input.value.trim()) return;
    const message = results.querySelector('[data-gc-predictive-message]');
    if (message) {
      status.textContent = message.textContent.trim();
      footer.hidden = message.dataset.gcPredictiveEmpty === 'true';
    }
  }).observe(results, {childList: true});
  footer.hidden = !input.value.trim();
})();
